module.exports = __webpack_public_path__ + "static/media/newsbg.bac16a4b.jpg";